import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Stack, Typography } from "@mui/material";
import Icon from "../../../Icon";
import PropTypes from "prop-types";
import { format } from "date-fns";
import CreativeCard from "./CreativeCard";
import ArtworkStatus from "../../../ArtworkStatus";
function index(props) {
    const { schedule, mediaName, mediaOptionName, toolName, frequency, startDate, endDate } = props;
    const renderBody = () => {
        var _a;
        if (((_a = schedule === null || schedule === void 0 ? void 0 : schedule.artwork) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return (_jsxs(_Fragment, { children: [_jsx(Stack, Object.assign({ divider: _jsx(Divider, {}), spacing: 2 }, { children: schedule.artwork.map(({ name, url }, idx) => (_jsx(CreativeCard, { data: { name, url, frequency } }, idx))) })), _jsx(Divider, { sx: { mt: "8px" } })] }));
        }
        return (_jsx(Stack, Object.assign({ justifyContent: "center", height: "inherit" }, { children: _jsx(Typography, Object.assign({ variant: "h3", textAlign: "center" }, { children: "No Artwork Uploaded Yet" })) })));
    };
    return (_jsxs(Stack, Object.assign({ p: 2, spacing: 6 }, { children: [_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", spacing: 2 }, { children: [_jsx(Icon, { height: 24, width: 24, color: "#172B4D", iconName: toolName }), _jsxs(Typography, Object.assign({ variant: "h3", fontWeight: "fontWeightMedium" }, { children: [mediaOptionName, " on ", mediaName] })), _jsx(ArtworkStatus, { scheduledDate: schedule === null || schedule === void 0 ? void 0 : schedule.date })] })), _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "space-between", sx: { backgroundColor: "brand.light", borderRadius: "8px", padding: "12px 16px" } }, { children: [_jsx(Typography, Object.assign({ variant: "h5", fontWeight: "fontWeightMedium" }, { children: "List of Media" })), _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [_jsx(Typography, Object.assign({ variant: "caption", color: "text.mid" }, { children: "Dates:" })), _jsx(Typography, Object.assign({ variant: "h6" }, { children: `${format(new Date(startDate), "do MMM")} to ${format(new Date(endDate), "do MMM")}` }))] }))] })), _jsx(Box, Object.assign({ sx: {
                    height: "192px",
                    overflowY: "scroll",
                    paddingRight: "5px",
                    "&::-webkit-scrollbar": {
                        width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                        background: "#B3BAC4",
                        height: "4px",
                        borderRadius: "10px",
                    }
                } }, { children: renderBody() }))] })));
}
index.propTypes = {
    schedule: PropTypes.object,
    toolName: PropTypes.oneOf([
        "airport",
        "cinema",
        "digital",
        "hyperlocal",
        "influencer-marketing",
        "magazine",
        "newspaper",
        "nontraditional",
        "outdoor",
        "radio",
        "television",
    ]),
    mediaName: PropTypes.string,
    mediaOptionName: PropTypes.string,
    frequency: PropTypes.string,
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
};
export default index;
